import {Injectable} from '@angular/core'
import {Mutation, Query} from 'apollo-angular'
import gql from 'graphql-tag'
import {OrderDetail, OrderDetailInput} from '../../../../api/graphql'

interface Response {
    addOrderDetail: OrderDetail
}

interface Param {
    orderDetail: OrderDetailInput
}

@Injectable({
    providedIn: 'root'
})
export class AddOrderDetailMutation extends Mutation<Response, Param> {
    document = gql`

        mutation($orderDetail: OrderDetailInput!) {
            addOrderDetail(orderDetail: $orderDetail) {
                additionalPrice
                createdAt
                food {
                    category {
                        description
                        id
                        name
                        registeredAt
                    }
                    description
                    id
                    name
                    price
                    registeredAt
                    type
                }
                history {
                    date
                    id
                    status
                    user {
                        id
                        dni
                        names
                    }
                }
                id
                observations
                quantity
                status
            }
        }
    `
}
